<ng-content></ng-content>
<ng-content select="label"></ng-content>
<ng-content select="[etAtomsTimeError]"></ng-content>
